module.exports = __webpack_public_path__ + "static/media/junhengx.002bc97a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/junhengx.png
// module id = 190
// module chunks = 0 1